import axiosInstance from 'ns_libs/nsAxios';
import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import { IProFormaData } from 'views/ProFormaTable/types';

const getProFormaModels = async (): Promise<IProFormaData[]> => {
    const response = await axiosInstance.get(API_ENDPOINTS.PRO_FORMA_MODELS);
    return response.data;
};

const useProFormaModels = () => useQuery({
    queryKey: ['proFormaModelOptions'],
    queryFn: () => getProFormaModels(),
});

export default useProFormaModels;
